const config = {
  baseUrl: 'https://beta-th-api.dimorder.com',
  mpUrl: 'https://beta-th-mp-order.dimorder.com',
}

export default config
